import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useIsMobile } from '@repo/common';
import InvoiceHeaderNavigator from './Invoice/InvoiceHeaderNavigator';
import Invoice from './Invoice/Invoice';
import BillingHistory from './BillingHistory/BillingHistory';
import {
  getInvoiceDetail,
  getPaymentLogHistories,
  getPaymentLogHistoriesByInvoice,
} from '../../../api/payment/payment.api';

const ViewInvoice = () => {
  const isMobile = useIsMobile();
  const [invoiceData, setInvoiceData] = useState(null);
  const [historiesData, setHistoriesData] = useState([]);
  const [searchParams] = useSearchParams();
  const invoiceNumber = searchParams.get('invoice');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const invoiceData = await getInvoiceDetail(invoiceNumber);
        setInvoiceData(invoiceData);

        const historyData = invoiceData?.paymentId
          ? await getPaymentLogHistories(invoiceData.paymentId)
          : await getPaymentLogHistoriesByInvoice(invoiceNumber);
        setHistoriesData(historyData);
      } catch (e) {
        console.error(e);
      }
    };

    fetchData();
  }, [invoiceNumber]);

  return (
    <div className='flex flex-col items-start w-full min-h-[973px] pb-15 gap-4'>
      {!isMobile && <InvoiceHeaderNavigator />}
      <div className='flex flex-col items-start gap-4 tabletH:gap-[30px] w-full'>
        <Invoice data={invoiceData} />
        <BillingHistory data={historiesData} invoiceData={invoiceData} />
      </div>
    </div>
  );
};

export default ViewInvoice;
